import React, { useRef, useState } from "react";
import { ButtonStyleAzul, ButtonStyleVerde, CssTextField, DivBackgroundDasboard, MaxDiv, PaperStyle, TypographyStyleSecundary } from "../../../styles/Styles";
import { useLocation, useNavigate } from "react-router-dom";
import HeaderCustom from "../../../components/header/HeaderCustom";
import { Box, Alert, Snackbar } from '@mui/material';
import { AccountBalance, AccountCircle, AlternateEmail, Email, FolderShared, Home } from "@mui/icons-material";
import SplashLoading from "../../../components/splashLoading/SplashLoading";
import alert from '../../../assets/alert.json';
import rechazado from '../../../assets/rechazado.json';
import { postConsultaPagoAlias } from "../../../api/Api";
import Lottie from "lottie-react-web";
import { ButtonFlotante } from "../../../components/botonQr/ButtonFlotante";

const PaymentVerificacionPage = () => {
    const [cargando, setCargando] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [mensaje, setMensaje] = useState('');
    const [openAlert, setOpenAlert] = useState(false);
    const [textRequest, setTextRequest] = useState(true);

    let history = useNavigate();

    const { state } = useLocation();

    console.log("state===>verificacion", state);


    const handleCloseAlert = () => {
        setOpenAlert(false);
    }





    const handleApiConsultas = () => {
        let bodyData = {};
        bodyData.idOperacion = state?.idOperacion;
        bodyData.timeout = "10";

        setCargando(true);

        postConsultaPagoAlias(bodyData)
            .then(response => {
                // console.log("response===>", response);
                if (response.header.codRespuesta === '0') {

                    if (response.data.estado === "AP") {
                        setCargando(false);

                        history('/home/payment/confirmacion', { state: response.data, replace: true });
                    } else if (response.data.estado === "RE") {
                        setCargando(false);
                        setOpenAlert(true);
                        setSeverity('warning');
                        setMensaje('El pago fue rechazado');
                        setTextRequest(false);
                    } else if (response.data.estado === "PE") {
                        setCargando(false);
                        setOpenAlert(true);
                        setSeverity('warning');
                        setMensaje('El pago se encuentra pendiente');
                        setTextRequest(true);
                    }

                } else {
                    setCargando(false);
                    setOpenAlert(true);
                    setSeverity('warning');
                    setMensaje(response.header.txtRespuesta);
                }
            })
            .catch(error => {
                console.log("error===>", error);
                setCargando(false);
                setOpenAlert(true);
                setSeverity('error');
                setMensaje('Error al consultar el pago');

            })
    }




    return (
        <HeaderCustom title="Sicoop Comercios">
            <MaxDiv>
                {state && (
                    <PaperStyle>
                        <div>
                            {textRequest ? (
                                <Box>
                                    <TypographyStyleSecundary component="h5" variant="h5" align='center'>
                                        Su pago se encuentra pendiente
                                    </TypographyStyleSecundary>

                                    <TypographyStyleSecundary gutterBottom variant="subtitle1" align='center'>
                                        Verifica tu pago con el siguiente botón
                                    </TypographyStyleSecundary>

                                    <TypographyStyleSecundary gutterBottom variant="subtitle1" align='center'>
                                        El pago puede demorar hasta 5 minutos
                                    </TypographyStyleSecundary>
                                </Box>
                            ) : (
                                <Box>
                                    <TypographyStyleSecundary component="h5" variant="h5" align='center'>
                                        Su pago fue rechazado
                                    </TypographyStyleSecundary>

                                    <TypographyStyleSecundary gutterBottom variant="subtitle1" align='center'>
                                        Para más información comuníquese al (021) 729 7777.
                                    </TypographyStyleSecundary>
                                </Box>
                            )}



                            <Lottie
                                options={{
                                    // animationData: animationcheck,
                                    animationData: (textRequest) ? alert : rechazado,
                                }}
                                width={300}
                                height={300}
                            />




                            <Box sx={{}} mt={2}>
                                {textRequest ? (
                                    <ButtonStyleVerde
                                        variant="contained"
                                        style={{
                                            width: '100%',
                                            height: '50px',
                                            borderRadius: '10px'
                                        }}
                                        startIcon={<AccountBalance />}
                                        onClick={handleApiConsultas}
                                    >
                                        Verificar Pago
                                    </ButtonStyleVerde>
                                ) : (
                                    <ButtonStyleAzul
                                        variant="contained"
                                        style={{
                                            width: '100%',
                                            height: '50px',
                                            borderRadius: '10px'
                                        }}
                                        startIcon={<Home />}
                                        onClick={() => history('/home', { replace: true })}
                                    >
                                        Volver
                                    </ButtonStyleAzul>
                                )}
                            </Box>
                        </div>

                    </PaperStyle>
                )}

                {/*agregar boton flotante*/}
                <ButtonFlotante />
            </MaxDiv>

            <Snackbar open={openAlert} autoHideDuration={10000} onClose={handleCloseAlert}>
                <Alert
                    onClose={handleCloseAlert}
                    severity={severity}
                    elevation={6}
                // variant="filled"
                >
                    {mensaje}
                </Alert>
            </Snackbar>

            {cargando && <SplashLoading cargando={cargando} />}
        </HeaderCustom>
    )
}

export default PaymentVerificacionPage;